import placeholderImage from '@/assets/img/place_holder_image.png'

const vehicleResources = [
  {
    uuid: 'FB2C082F-7513-4FDE-B4E2-A896D19441C7',
    name: 'Safari 59',
    type: 'vehicle',
    category: 'Safari',
    plate: 'UVK-5H59',
    capacity: 10,
    description: 'Safari para 10 passageiros, além do motorista.',
    driver:{},
    fuel_category: 'fossil-fuels',
    driver_required: true
  },
  {
    uuid: 'F6AE3438-270A-4C8E-BABD-9520685CC9BB',
    name: 'Safari 60',
    type: 'vehicle',
    category: 'Safari',
    plate: 'UVK-5H60',
    capacity: 10,
    description: 'Safari para 10 passageiros, além do motorista.',
    driver:{},
    fuel_category: 'fossil-fuels',
    driver_required: true
  },
  {
    uuid: 'FC42CE2E-BE78-480B-BF09-B9F1D1CA9EED',
    name: 'Safari 62',
    type: 'vehicle',
    category: 'Safari',
    plate: 'UVK-5H62',
    capacity: 10,
    description: 'Safari para 10 passageiros, além do motorista.',
    driver:{},
    fuel_category: 'fossil-fuels',
    driver_required: true
  },
  {
    uuid: '162421F1-B290-4F61-B591-AC133BBAD08F',
    name: 'Safari 74',
    type: 'vehicle',
    category: 'Safari',
    plate: 'SYV-9H74',
    capacity: 10,
    description: 'Safari para 10 passageiros, além do motorista.',
    driver:{},
    fuel_category: 'fossil-fuels',
    driver_required: true
  },
  {
    uuid: 'CC0B43DD-C3F3-43A7-9B25-FA13ACEB1FC0',
    name: 'Micro-ônibus 16',
    type: 'vehicle',
    category: 'Micro-ônibus',
    plate: 'PJV-5016',
    capacity: 20,
    description: 'Micro-ônibus para 20 passageiros, além do motorista.',
    driver:{},
    fuel_category: 'fossil-fuels',
    driver_required: true
  },
  {
    uuid: 'AE42A918-C032-487D-A250-EE1756EA64B9',
    name: 'Off Road',
    type: 'vehicle',
    category: 'Off Road',
    plate: '0FF-R04D',
    capacity: 0,
    description: 'veículo do cliente',
    driver:{},
    fuel_category: 'fossil-fuels',
    driver_required: false
  },
  {
    uuid: '361286FD-88AD-44FA-8D0B-5EC25A591539',
    name: 'Quadriciclo 01',
    type: 'vehicle',
    category: 'Quadriciclo',
    plate: 'QDC-0001',
    capacity: 2,
    description: 'Quadriciclo para 2 passageiros, além do motorista.',
    driver:{},
    fuel_category: 'fossil-fuels',
    driver_required: false
  },
  {
    uuid: '030EC0B4-50CB-4806-A3CF-E63217C2AA75',
    name: 'Quadriciclo 02',
    type: 'vehicle',
    category: 'Quadriciclo',
    plate: 'QDC-0002',
    capacity: 2,
    description: 'Quadriciclo para 2 passageiros, além do motorista.',
    driver:{},
    fuel_category: 'fossil-fuels',
    driver_required: false
  },
  {
    uuid: 'C95BEFA3-A76F-42A5-A49E-0EFE42D3CE30',
    name: 'Quadriciclo 03',
    type: 'vehicle',
    category: 'Quadriciclo',
    plate: 'QDC-0003',
    capacity: 2,
    description: 'Quadriciclo para 2 passageiros, além do motorista.',
    driver:{},
    fuel_category: 'fossil-fuels',
    driver_required: false
  },
  {
    uuid: '96371724-4F4C-4D19-A473-59911E0E910F',
    name: 'Buggy 01',
    type: 'vehicle',
    category: 'Buggy',
    plate: 'BUG-7768',
    capacity: 4,
    description: 'Buggy para 4 passageiros, além do motorista.',
    driver:{},
    fuel_category: 'fossil-fuels',
    driver_required: true
  },
  {
    uuid: 'C95BEFA3-A76F-42A5-A49E-0EFE42D3CE31',
    name: 'Lancha 01',
    type: 'vehicle',
    category: 'Lancha',
    plate: 'LAN-0001',
    capacity: 1,
    description: 'Lancha para 10 passageiros, além do piloto.',
    driver:{},
    fuel_category: 'fossil-fuels',
    driver_required: true
  },
  {
    uuid: 'D3DC3ECC-3B4D-483B-ABED-0955C0EAD506',
    name: 'Trilha',
    type: 'vehicle',
    category: 'Trilha',
    plate: 'AND-0001',
    capacity: 0,
    description: 'percurso feito andando.',
    driver:{},
    fuel_category: 'human-powered',
    driver_required: false
  },
  /*
  {
    uuid: '83E17F84-9E66-48F0-998D-6BB26979B9BE',
    name: 'Buggy 02',
    type: 'vehicle',
    category: 'Buggy',
    plate: 'BUG-5002',
    capacity: 4,
    description: 'Buggy para 4 passageiros, além do motorista.',
    driver:{},
    fuel_category: '',
    driver_required: true
  },*/
].map((vehicle) => ({
  ...vehicle,
  image: placeholderImage,
}))

const fuelCategories = [
  {
    "category": "Fósseis",
    "category_slug": "fossil-fuels",
    "icon": "fa-solid fa-gas-pump",
    "description": "Veículos que utilizam combustíveis derivados do petróleo ou gás natural, operados por motores de combustão interna.",
    "fuels_or_sources": [
      "Gasolina",
      "Diesel",
      "Gás Natural Veicular (GNV)",
      "Querosene de Aviação"
    ]
  },
  {
    "category": "Elétricos e Eletrificados",
    "category_slug": "electric-and-electrified",
    "icon": "fa-solid fa-bolt",
    "description": "Veículos movidos total ou parcialmente por motores elétricos, utilizando baterias, hibridização ou redes integradas.",
    "fuels_or_sources": [
      "Eletricidade (Bateria/BEV)",
      "Híbrido (Combustão + Elétrico)",
      "Rede Elétrica Suspensa (Trólebus/Bonde)",
      "Indução/Levitação Magnética"
    ]
  },
  {
    "category": "Biocombustíveis e Renováveis",
    "category_slug": "biofuels-and-renewables",
    "icon": "fa-solid fa-leaf",
    "description": "Alternativas sustentáveis de energia limpa ou de base biológica para a redução de emissões de carbono.",
    "fuels_or_sources": [
      "Etanol",
      "Biodiesel",
      "Biometano",
      "Hidrogênio (Célula de Combustível)"
    ]
  },
  {
    "category": "Força Humana",
    "category_slug": "human-powered",
    "icon": "fas fa-walking",
    "description": "Meios de transporte que dependem exclusivamente do esforço físico ou da propulsão mecânica do próprio usuário.",
    "fuels_or_sources": [
      "Propulsão por Pedais",
      "Propulsão por Remo",
      "Propulsão por Empuxo/Gravidade"
    ]
  },
  {
    "category": "Tração Animal",
    "category_slug": "animal-traction",
    "icon": "fa-solid fa-horse",
    "description": "Veículos tradicionais ou de carga movidos pela força de animais domesticados.",
    "fuels_or_sources": [
      "Força Animal (Equinos/Bovinos/Caninos)"
    ]
  }
]

export function fuelCategoryFor(slug) {
  const key = String(slug || '').trim()
  if (!key) return null
  return fuelCategories.find((item) => item.category_slug === key) || null
}

export { fuelCategories }
export default vehicleResources
